import {createFeatureSelector, createSelector} from '@ngrx/store';
import {AppState, CHECKOUT_FEATURE_KEY} from '../../../app.state';

export const checkoutFeature = createFeatureSelector<AppState>(CHECKOUT_FEATURE_KEY);
export const selectLoading = createSelector(
  checkoutFeature,
  (state: AppState) => {
    return state.checkout.isLoading;
  }
);
export const selectResponse = createSelector(
  checkoutFeature,
  (state: AppState) => state?.checkout?.data?.data
);
export const selectNotifications = createSelector(
  checkoutFeature,
  (state: AppState) => state?.checkout?.data?.notification
);
export const selectItems = createSelector(
  checkoutFeature,
  (state: AppState) => state.checkout.data?.data?.summaryItems
);
export const selectContact = createSelector(
  checkoutFeature,
  (state: AppState) => state.checkout.data?.data?.contact
);
export const selectRequeriments = createSelector(
  checkoutFeature,
  (state: AppState) => state.checkout.data?.data?.requeriments
);
export const selectPaymentMethods = createSelector(
  checkoutFeature,
  (state: AppState) => state.checkout.data?.data?.paymentMethods?.paymentProfiles
);
export const selectRequirements = createSelector(
  checkoutFeature,
  (state: AppState) => state.checkout.data?.data?.requeriments
);
export const selectSummary = createSelector(
  checkoutFeature,
  (state: AppState) => state.checkout.data?.data?.summary
);
export const selectSummaryItems = createSelector(
  checkoutFeature,
  (state: AppState) => state.checkout.data?.data?.cleanSummaryData
);
export const selectShipments = createSelector(
  checkoutFeature,
  (state: AppState) => state.checkout.data?.data?.shipments
);

export const selectShipmentNotification = (index: number) => createSelector(
  checkoutFeature,
  (state: AppState) => {
    return state.checkout.data?.data?.shipments[index]?.notificationItem??{
        messageType: 0,
        message: "",
        color: ""
     };
  }
);
export const selectShipmentsItemNotification = (shipment: number,item: number) => createSelector(
  checkoutFeature,
  (state: AppState) => {
    return state.checkout.data?.data?.shipments[shipment]?.items[item]?.notificationItem??{
      messageType: 0,
      message: "",
      color: ""
   };
  }
);

